import { Button, DialogClose, InterceptDialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PortalContainerContext } from "@/contexts";
import useSegmentEvent from "@/hooks/useSegmentEvent";

const UpsellOptionModal = ({
  children,
  show = false,
}: {
  children: React.ReactNode;
  show?: boolean;
}) => {
  const { t } = useTranslation(["importDeposit"]);
  const { sendSegmentEvent } = useSegmentEvent();

  const { container } = use(PortalContainerContext);

  return (
    <InterceptDialog
      show={show}
      title={t("importDeposit:upsellOptionModal.title")}
      description={t("importDeposit:upsellOptionModal.description")}
      warningMessage={t("importDeposit:upsellOptionModal.warning")}
      portalContainer={container as Element}
      footer={
        <DialogClose asChild>
          <Button
            shape="solid"
            onClick={() => sendSegmentEvent("option_subscription")}
            as={Link}
            to="/options/subscription?option=import_deposit"
          >
            {t("importDeposit:upsellOptionModal.cta")}
          </Button>
        </DialogClose>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellOptionModal;
